import script from "./SetGames.vue?vue&type=script&setup=true&lang=js"
export * from "./SetGames.vue?vue&type=script&setup=true&lang=js"

import "./SetGames.vue?vue&type=style&index=0&id=56cbd940&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56cbd940"]])

export default __exports__